/**
 * Super Admin - 슈퍼관리자 전용 상태 관리
 * 
 * 일반 유저 시스템(My.ts)과 완전히 분리된 독립적인 상태 관리
 * sessionStorage를 사용하여 탭/세션 단위로 상태 유지
 */

const STORAGE_KEY = 'nextpod_super_admin';

interface SuperAdminInfo {
    id: string;
    email: string;
    name: string;
}

interface StoredData {
    isLoggedIn: boolean;
    info: SuperAdminInfo | null;
}

export class SuperAdmin {
    private static _isLoggedIn: boolean = false;
    private static _info: SuperAdminInfo | null = null;

    private constructor() { }

    // Initialize from sessionStorage on app start
    static initialize() {
        const stored = sessionStorage.getItem(STORAGE_KEY);
        if (stored) {
            try {
                const data: StoredData = JSON.parse(stored);
                this._isLoggedIn = data.isLoggedIn;
                this._info = data.info;
            } catch {
                this.clear();
            }
        }
    }

    static get isLoggedIn(): boolean {
        return this._isLoggedIn;
    }

    static get info(): SuperAdminInfo | null {
        return this._info;
    }

    static get id(): string {
        return this._info?.id ?? '';
    }

    static get email(): string {
        return this._info?.email ?? '';
    }

    static get adminName(): string {
        return this._info?.name ?? '';
    }

    static login(info: SuperAdminInfo) {
        this._isLoggedIn = true;
        this._info = info;
        this.persist();
    }

    static clear() {
        this._isLoggedIn = false;
        this._info = null;
        sessionStorage.removeItem(STORAGE_KEY);
    }

    private static persist() {
        const data: StoredData = {
            isLoggedIn: this._isLoggedIn,
            info: this._info,
        };
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    }
}

// Initialize on module load
SuperAdmin.initialize();
